export default __webpack_public_path__ + "static/media/item1.70a4a820.png";